import RenderIf from "common/components/RenderIf";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import { LEADS_FACETS } from "common/constants";
import type { LeadsSearchParams, SelectedFacetParam } from "common/types";

import { DRIP_FACET_KEYS } from "../../../../../constants";
import DripFacet from "./DripFacet";
import FavoriteFilter from "./FavoriteFilter";

import type { JSX } from "react";

interface FiltersProps {
  resetFiltersButton: JSX.Element;
  searchParams: LeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: Partial<LeadsSearchParams<SelectedFacetParam>>,
  ) => void;
}

export default function DesktopFilters({
  resetFiltersButton,
  searchParams,
  setSearchParams,
}: FiltersProps) {
  return (
    <div className="flex gap-x-3">
      <section className="flex flex-wrap items-center gap-2">
        {DRIP_FACET_KEYS.map((facetKey) => {
          const { icon: Icon, label } = LEADS_FACETS[facetKey];
          const searchKey = facetKey === "schools" ? "education" : facetKey;

          const selectedFiltersCount = searchParams[searchKey].length;

          return (
            <DropdownMenu key={facetKey}>
              <DropdownMenuTrigger asChild>
                <FilterButton
                  size="sm"
                  leftIcon={<Icon weight="fill" />}
                  rightIcon={
                    <RenderIf condition={!!selectedFiltersCount}>
                      <span className="flex size-4 shrink-0 items-center text-button-xs justify-center rounded-full bg-black-950 text-white">
                        {selectedFiltersCount}
                      </span>
                    </RenderIf>
                  }
                >
                  {label}
                </FilterButton>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-80" align="start">
                <DripFacet
                  facetKey={facetKey}
                  searchKey={searchKey}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                />
              </DropdownMenuContent>
            </DropdownMenu>
          );
        })}
        <FavoriteFilter
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </section>

      {resetFiltersButton}
    </div>
  );
}
